import { render, staticRenderFns } from "./PriceListsForm.vue?vue&type=template&id=01cc2317&"
import script from "./PriceListsForm.vue?vue&type=script&lang=js&"
export * from "./PriceListsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports